import { Typography } from '@mui/material';
import { Column, usePagination, useRowSelect, useSortBy, useTable } from 'react-table';
import { IAdditionalQuoteDocumentationItem } from 'shared/types';
import { additionalQuoteDocumentationTableColumns } from './columns/additional-quote-documentation-columns';

const defaultColumn: Partial<Column<IAdditionalQuoteDocumentationItem>> = {
  Filter: () => null,
  Cell: ({ value = '' }) => <Typography variant='body2'>{value}</Typography>,
  disableFilters: true,
  width: 150,
  minWidth: 150,
  maxWidth: 150,
  align: 'inherit',
};

export function useAdditionalQuoteDocumentationTableInstance(data: IAdditionalQuoteDocumentationItem[]) {
  return useTable<IAdditionalQuoteDocumentationItem>(
    {
      columns: additionalQuoteDocumentationTableColumns,
      data,
      initialState: { pageSize: 100 },
      defaultColumn,
      autoResetFilters: false,
    },
    useSortBy,
    usePagination,
    useRowSelect
  );
}
